<mat-dialog-content>
    <div class="example-viewer-wrapper mat-white-bg mat-elevation-z2" style = "min-width:380px;">
        <div style = "background:#eee;margin:0;height:30px;padding-left:5px;padding-top:5px;">{{headerText}}</div>
        <div class="example-viewer-body">
            <div class="example-container">
                <mat-form-field>
                    <input matInput [(ngModel)]="this.onderwerpItem.Onderwerp" placeholder="Onderwerp">
                </mat-form-field>
                <div>
                    <fieldset style = "height:350px;">
                        <legend>Bedrijf of activiteit:</legend>
                        <div>
                            <p>Activiteit:</p>
                            <p-dropdown [style]="{'width':'230px'}" [options]="activiteiten" [(ngModel)]="this.onderwerpItem.UrenCatID" ></p-dropdown >
                           
                        </div>
                        <div>
                            <p>Bedrijf:</p>
                            <p-dropdown [style]="{'width':'230px'}" [filter]="true" [options]="bedrijven" [(ngModel)]="this.onderwerpItem.BedrijfID" ></p-dropdown >
                        </div>
                        <div>
                            <mat-form-field style = "width:230px;">
                                <textarea matInput style = "height:125px;resize: none;" [(ngModel)]="this.onderwerpItem.Notitie" placeholder="Intern Notitie:"></textarea>
                            </mat-form-field>
                        </div>
                    </fieldset>
                    <fieldset style = "min-height:350px;">
                        <legend>Medewerker(s):</legend>
                        <div style = "float:left;">
                            <div>
                                <mat-radio-group [(ngModel)]="this.rbMedewerkers" class="example-radio-group">
                                    <mat-radio-button class="example-radio-button"  [value]="1">Nog (later) in te plannen</mat-radio-button>
                                    <mat-radio-button class="example-radio-button"  [value]="2">Kies 1 of meer namen uit lijst</mat-radio-button>
                                </mat-radio-group> 
                            </div>
                            <div>
                            
                                    <p-dropdown [options]="medewerkerFuncties" [(ngModel)]="this.onderwerpItem.FunctieID" placeholder="Functie medewerker:">
                                    </p-dropdown>
                              
                            </div>
                            <div>
                                <mat-checkbox [(ngModel)]="this.onderwerpItem.Storing">Storing</mat-checkbox>
                            </div>
                        </div>
                        <div style = "float:left;">
                            <p-listbox [style]="{'width':'100%'}" filter="filter" multiple="multiple" checkbox="checkbox" [options]="Medewerkers" [(ngModel)]="selectedMedewerkers" [listStyle]="{'max-height':'250px'}"></p-listbox>
                        </div>
                    </fieldset>
                 </div>
                 <div>
                    <fieldset style = "height:180px;">
                        <legend>Periode:</legend>
                       <div>
                            <mat-form-field>
                                <input matInput [(ngModel)]="this.onderwerpItem.Start"  [matDatepicker]="startdatum" placeholder="Startdatum">
                                <mat-datepicker-toggle matSuffix [for]="startdatum"></mat-datepicker-toggle>
                                <mat-datepicker #startdatum></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field>
                                <input matInput [(ngModel)]="this.onderwerpItem.Tot"  [matDatepicker]="einddatum" placeholder="Einddatum">
                                <mat-datepicker-toggle matSuffix [for]="einddatum"></mat-datepicker-toggle>
                                <mat-datepicker #einddatum></mat-datepicker>
                            </mat-form-field>
                        </div> 
                    </fieldset>
                    <fieldset style = "height:180px;">
                            <legend>Tijd:</legend>
                            <div>
                                <mat-form-field>
                                    <input matInput type="time" [(ngModel)]="startTijd" >
                                </mat-form-field>
                            </div>
                            <div>
                                <mat-form-field>
                                    <input matInput type="time" [(ngModel)]="totTijd"   >
                                </mat-form-field>
                            </div>
                        </fieldset>
                    <fieldset style = "height:180px;max-width:420px;">
                            <legend>Intern Monteur:</legend>
                            <mat-form-field class="example-full-width">
                                <textarea matInput placeholder="Intern monteur informatie:"></textarea>
                            </mat-form-field>
                    </fieldset>
                </div>
                <fieldset>
                    <legend>Herhaling:</legend>
                    <fieldset style = "float:left;">
                        <legend>Patroon:</legend>
                            <mat-radio-group [(ngModel)]="this.onderwerpItem.Patroon" class="example-radio-group">
                            <mat-radio-button class="example-radio-button" [value]="0">Geen (op 1 dag)</mat-radio-button>
                            <mat-radio-button *ngIf="this.onlyToday == false" class="example-radio-button" [value]="1">Dagelijks (meer dagen)</mat-radio-button>                         
                            <mat-radio-button *ngIf="this.onlyToday == false" class="example-radio-button" (click)="cbWekelijks()" [value]="2">Wekelijks</mat-radio-button>
                            <mat-radio-button *ngIf="this.onlyToday == false" class="example-radio-button"  [value]="3">Cyclus</mat-radio-button>                    
                        </mat-radio-group> 
                    </fieldset> 
                    <table *ngIf="toonHerhalingWeek" style = "float:left;max-width:420px;">
                        <tr>
                            <td>Herhaal iedere 
                                <mat-form-field style = "width:20px;">
                                    <input matInput [(ngModel)]="this.onderwerpItem.Weken" >
                                </mat-form-field>
                                Week(en) binnen gekozen data op:
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <mat-checkbox class = "planningfilterbutton"  [(ngModel)]="cbMaandag">Maandag</mat-checkbox>
                                <mat-checkbox class = "planningfilterbutton"  [(ngModel)]="cbDinsdag">Dinsdag</mat-checkbox>
                                <mat-checkbox class = "planningfilterbutton"  [(ngModel)]="cbWoensdag">Woensdag</mat-checkbox>
                                <mat-checkbox class = "planningfilterbutton"  [(ngModel)]="cbDonderdag">Donderdag</mat-checkbox>
                                <mat-checkbox class = "planningfilterbutton"  [(ngModel)]="cbVrijdag">Vrijdag</mat-checkbox>
                                <mat-checkbox class = "planningfilterbutton"  [(ngModel)]="cbZaterdag">Zaterdag</mat-checkbox>
                                <mat-checkbox class = "planningfilterbutton"  [(ngModel)]="cbZondag">Zondag</mat-checkbox>
                            </td>
                        </tr>
                    </table>
                </fieldset>
                <div class = "opslaanclass" fxLayout="row">
                    <button mat-raised-button (click)="btnTerug()" >Terug</button>
                    <button style = "margin-left:20px;" mat-raised-button (click)="btnOpslaan()" color="accent">Opslaan</button>
                    <button style = "margin-left:20px;" mat-raised-button (click)="btnVerwijderen()" color="warn">Verwijderen    </button>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>